<template>
  <div>
    <input type="hidden" :value="JSON.stringify(services)" name="invoice_template_items">

    <div class="portlet light portlet-fit invoice-template-details-portlet" @keydown="downKeyAdd">
      <div class="portlet-title" v-if="!formMode">
        <div class="caption">
          <i class="fa fa-list"></i>
          <span class="caption-subject bold uppercase">Services et pièces</span>
        </div>
        <div class="tools">
          <a href="javascript:;" class="collapse" data-original-title="" title='Afficher / Cacher'> </a>
        </div>
      </div>
      <div class="portlet-body">
        <div v-if="loading">
          <div class="text-center">
            <span style="font-size: 22px"><i class="fa fa-refresh fa-spin"></i></span>
          </div>
        </div>
        <div v-else>
          <table id="invoice-template-details-table" class="table table-bordered" style="margin-bottom: 5px">
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th style="width: 400px; min-width: 400px;">Services et pièces</th>
                <th>Description</th>
                <th class="width-min-nowrap">Quantité</th>
                <th class="width-min-nowrap">Heures</th>
              </tr>
            </thead>
            <draggable v-model="items" tag="tbody" handle=".draggable-handle" @update="handleChange">
                <tr v-bind:key="index" v-for="(item, index) in items" class="item-row" :class="{'is-service': item.part_index === undefined}">
                  <td class="width-min-nowrap" :class="{'draggable-handle' : item.part_index === undefined}"  style="padding: 3px 8px; vertical-align: middle; font-size: 22px; cursor:move">
                    <i v-if="item.part_index === undefined" class="fa fa-bars"></i>
                  </td>
                  <td class="width-min-nowrap text-center" :style="{'padding': item.part_index === undefined ? '8px' :'3px 8px'}">
                    <div>
                      <a class="btn btn-circle btn-icon-only btn-default tooltips mr-0" @click="removeItem(item.service_index, item.part_index)" data-container="body" data-placement="top" data-original-title="Retourner dans l'inventaire" href="javascript:;" :title="item.part_index === undefined ? 'Supprimer':'Retourner dans l\'inventaire'">
                        <i v-if="item.part_index === undefined" class="icon-trash"></i><span v-if="item.part_index !== undefined">I</span>
                      </a>
                    </div>
                  </td>
                  <td class="width-min-nowrap" style="vertical-align: top;">
                    <span :title="item.part_index === undefined ? 'Service' :'Pièce'">
                      {{item.part_index === undefined ? 'S' : 'P'}}
                    </span>
                  </td>
                  <td class="input" style="width: 400px; min-width: 400px;">
                    <div>
                      <input type="hidden" v-model="item.invoice_template_detail_invoice_template_id">
                      <input type="hidden" v-model="item.invoice_template_detail_service_id">
                        
                      <select-two-items v-if="item.type == 'service'"
                          :endpoint="itemEndpoint" 
                          :type="item.type" 
                          v-model="item.invoice_template_detail_item" 
                          @selected="onSelect(item.service_index, item.part_index, $event);" 
                          @clear="onClear(item.service_index, item.part_index)" 
                          :ref="`select2-service-${item.service_index}`"
                          :initial-value="(item.invoice_template_detail_item.id)?item.invoice_template_detail_item.id.toString():''"  
                          :initial-display="item.invoice_template_detail_item.text"
                          :add-form-base-end-point="baseEndpoint+'service/add'"
                          :add-form-title="'Ajout d\'un service'"
                          :add-form-selector="'#form_service'"
                          :add-text-input-selector="'#service_name'"
                          :edit-form-base-end-point="baseEndpoint+'service/edit'"
                          :edit-form-title="'Modifier un service'"
                          :edit-form-selector="'#form_service'"
                          :edit-text-input-selector="'#service_name'"
                          :allow-add="allowAddServices"
                          :allow-edit="allowEditServices"
                          :dropdownParent="formMode ? '.modal-invoice-template .modal-content' : 'body'" />
                      <select-two-items v-else-if="item.type == 'part'"
                          :endpoint="itemEndpoint" 
                          :type="item.type" 
                          v-model="item.invoice_template_detail_item" 
                          @selected="onSelect(item.service_index, item.part_index, $event);focus(index)" 
                          @clear="onClear(item.service_index, item.part_index)" 
                          :ref="`select2-part-${item.service_index}-${item.part_index}`"
                          :initial-value="(item.invoice_template_detail_item.id)?item.invoice_template_detail_item.id.toString():''"  
                          :initial-display="item.invoice_template_detail_item.text"
                          :add-form-base-end-point="baseEndpoint+'part/add'"
                          :add-form-title="'Ajout d\'une pièce'"
                          :add-form-selector="'#form_part'"
                          :add-text-input-selector="'#part_name'"
                          :edit-form-base-end-point="baseEndpoint+'part/edit'"
                          :edit-form-title="'Modifier une pièce'"
                          :edit-form-selector="'#form_part'"
                          :edit-text-input-selector="'#part_name'"
                          :allow-add="allowAddParts"
                          :allow-edit="allowEditParts"
                          :dropdownParent="formMode ? '.modal-invoice-template .modal-content' : 'body'" />
                        
                      <small v-if="item.part_index === undefined" style="font-size:15px">
                        <a href="javascript:;" @click="addPart(item.service_index)">+ Ajouter pièce</a>
                        <span> ({{item.parts.length}}  {{item.parts.length>1 ? 'pièces' : 'pièce'}})</span>
                      </small>
                    </div>
                  </td>
                  <td class="input">
                    <div >
                      <textarea ref="description-box" v-if="item.part_index === undefined" class="form-control" style="width:100%; min-height: 35px; resize: vertical" v-model="item.invoice_template_detail_description" @change="handleChange" @input="autoResize"></textarea>
                      <textarea ref="description-box" v-else class="form-control" style="width:100%; height: 35px; min-height: 35px; resize: vertical" v-model="item.invoice_template_detail_description" @change="handleChange" @input="autoResize"></textarea>
                    </div>
                  </td>
                  <td class="width-min-nowrap input" style="width: 100px">
                    <div>
                      <div>
                        <input style="width: 100px" class="form-control invoice_template_detail_qty select-on-focus" id="qty" ref="qty" type="number" v-model="item.invoice_template_detail_qty" @change="handleChange">
                      </div>
                    </div>                    
                  </td>
                  <td class="width-min-nowrap input" style="width: 100px">
                    <div v-if="item.part_index === undefined">
                      <div>
                        <input style="width: 100px" class="form-control invoice_template_detail_hours select-on-focus" id="hours" ref="hours" type="number" v-model="item.invoice_template_detail_hours" @change="handleChange">
                      </div>
                    </div>                    
                  </td>
                </tr>
            </draggable>   
            <tfoot style="border: none">
              <tr style="border: none">
                <td colspan="5" style="border: none">
                  <button  class="btn purple" @click="addService"><i class="fa fa-plus"></i> Ajouter un service</button>                  
                </td> 
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
// import Swal from 'sweetalert2';

export default {
  name: "invoice-template-detail-list",
  components: {
    draggable,
  },
  props: {
    invoicetemplateId: {
      type: String,
      required: true
    },
    baseEndpoint: {
      type: String,
      required: true
    },
    allowEditServices: {
      type: Boolean,
      default: true
    },
    allowAddServices: {
      type: Boolean,
      default: true
    },
    allowEditParts: {
      type: Boolean,
      default: true
    },
    allowAddParts: {
      type: Boolean,
      default: true
    },
    formMode: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      services: [],
      oldItems: [],
      loading: true,
      items: [],
      allItems: [],
      allExpanded: false,
      updateCounter: 0
    }
  },
  watch: {
    items: {
      handler(){
        //this.saveItems();
      },
      deep: true
    }
  },
  async mounted(){
      console.log("formMode : " + this.formMode);
     this.loading = true;
     await this.loadItems();
    $(".invoice-template-details-portlet").on("focus", "input.select-on-focus", function() {
      $(this).trigger("select");
    })
    window._vue_invoice_template_detail_list = this;
    setTimeout(() => {
      this.autoResize();
    }, 500);
  },
  computed:{
    itemEndpoint(){
      this.updateCounter;
      return this.baseEndpoint + "invoice/select2/allitems";
    },
    // isDifferent(){
    //   this.updateCounter;
    //   return JSON.stringify(this.services) != JSON.stringify(this.oldItems);
    // },
  },
  methods:{
    formatPartDisplay(part) {
      console.log("formatPartDisplay called with part:", part);
      const name = part.label || part.part_name || part.name || "";
      const supplierName = String(part.supplier_name || "").trim().replace(/^(?:\d+\s+)+/, "");
      const supplier = supplierName ? supplierName.slice(0, 8).trim() : "—";
      const inventory = part.part_inventory !== undefined && part.part_inventory !== null
        ? part.part_inventory
        : 0;

      return name + " - " + supplier + " - Q:[" + inventory + "]";
    },
    focus (index) {
      this.$nextTick(() => {
        this.$refs.qty[index].focus()
      })
    }, 
    async loadItems(){
      //this.loading = true;

      if(parseInt(this.invoicetemplateId) == 0){
        this.loading = false;
        this.recomputeItems();
        return;
      }

      let data = await $.get(this.baseEndpoint + "invoicetemplate/view/"+this.invoicetemplateId+"/details");

      this.services = data;
      this.loading = false;

      for (const res of data) {
        res.type = "service";
        res.expanded = true;
        
        if(res.invoice_template_detail_service_id != 0){
          res.invoice_template_detail_item = {
            id: "service-"+res.invoice_template_detail_service_id,
            item_id: res.invoice_template_detail_service_id,
            text: res.service_name,
            type: "service"
          };
        }
        else{
          console.log("adding null type item...")
          res.invoice_template_detail_item = {
            id: null,
            item_id: null,
            text: "",
            type: null
          };
        }

        var part_index = 0;

        for (const part of res.parts) {
          part.type = "part";

          if(part.invoice_template_detail_part_id != 0){
            part.invoice_template_detail_item = {
              text: this.formatPartDisplay(part),
              item_id: part.invoice_template_detail_part_id,
              id: "part-"+part.invoice_template_detail_part_id,
              type: "part"
            };
          }
          else{
            part.invoice_template_detail_item = {
              id: null,
              item_id: null,
              text: "",
              type: null
            };
          }
        }


      }
      
      this.recomputeItems();
      this.oldItems = JSON.parse(JSON.stringify(this.services));
    },
    autoResize() {
      if(this.$refs["description-box"] !== undefined){
        for (const textarea of this.$refs["description-box"]) {
          textarea.style.height = "10px";
          textarea.style.height = (textarea.scrollHeight+2) + "px";
        }
      }
    },
    round: function(number, precision){
      number = parseFloat(number);
      number += 0.00000001;
      return number.toFixed(2);
    },
    getNbPartsOfService: function(service_index){
      return this.services[service_index].parts.length;
    },
    removeEmptyLines: function(){
      for(var svc_ix in this.services){
        if(svc_ix == "move") continue;
        this.services[svc_ix].parts = this.services[svc_ix].parts.filter(function(part){
          return part.invoice_template_detail_part_id != null;
        })
      }

      this.services = this.services.filter(function(service){
        return service.parts.length != 0 || service.invoice_template_detail_service_id != null;
      })
    },
    saveItems: async function(){ 
      if(this.formMode) return;
      this.removeEmptyLines();
      let result = await $.post(this.baseEndpoint + "invoicetemplate/view/"+this.invoicetemplateId+"/details/save", {data: this.services});

      for (const serviceIx in result) {
        this.services[serviceIx].invoice_template_detail_id = result[serviceIx].invoice_template_detail_id
        let parts = result[serviceIx].parts;
        for (const partIx in parts) {
          if (Object.hasOwnProperty.call(parts, partIx)) {
            this.services[serviceIx].parts[partIx].invoice_template_detail_id = parts[partIx].invoice_template_detail_id
          }
        }
      }

      this.recomputeItems();
    },
    downKeyAdd(ev){
      if(ev.keyCode == '40'){
        ev.preventDefault();
        this.addService(ev);
      }
    },
    recomputeItems: function(){
      var allItems = [];
      var items = [];
      var service_index = 0;
      this.services.sort((a,b) => parseInt(a.invoice_template_detail_order) - parseInt(b.invoice_template_detail_order))
      this.services.forEach(function(service){
        service.service_index = service_index
        items.push(service);
        allItems.push(service);
        if(service.parts !== undefined){
          var part_index = 0;
          service.parts.sort((a,b) => parseInt(a.invoice_template_detail_order) - parseInt(b.invoice_template_detail_order))
          service.parts.forEach(function(part){
            part.part_index = part_index;
            part.service_index = service_index
            if(service.expanded){
              items.push(part);
            }
            allItems.push(part);
            part_index++;
          })
        }
        service_index++;
      });
      this.items = items;
      this.allItems = allItems;
    },
    toggleExpand: function(service_index){
      this.services[service_index].expanded = !this.services[service_index].expanded;

      var isExpandAll = false;
      this.services.forEach(function(service){
        if(!isExpandAll && service.expanded){
          isExpandAll = true;
        }
      });
      
      this.allExpanded = isExpandAll;
      this.recomputeItems();
      this.updateCounter++;
    },
    toggleExpandAll: function(){
      var that = this;
      this.allExpanded = !this.allExpanded;
      this.services.forEach(function(service){
        service.expanded = that.allExpanded;
      });
      this.recomputeItems();
      this.updateCounter++;
    },
    addService: function(event, data = null){
      var that = this;
     
      var index = 0;
      if(this.services[this.services.length-1] !== undefined){
        index = parseInt(this.services[this.services.length-1].invoice_template_detail_order ?? 0) + 1; // Index service
      }
      
      //console.log(this.services)
      let parts_status = true;

      if (!data || data == null || data == undefined) {
        console.log("No service data...." + that.invoicetemplateId);
        this.services.push({
          type: "service",
          invoice_template_detail_id: null,
          invoice_template_detail_item: {id:null, text:"", type:null},
          invoice_template_detail_part_id: null,
          invoice_template_detail_service_id: null,
          invoice_template_detail_invoice_template_id: that.invoicetemplateId,
          invoice_template_detail_description: "",
          invoice_template_detail_qty: "1.00",
          invoice_template_detail_hours: "0.00",
          service_index: index,
          invoice_template_detail_order: index,
          expanded: false,
          parts: []
        });

        setTimeout(()=>{
          var count = that.services.length - 1;
          //this.$refs["select2-service-"+count][0].open()
        }, 50)
      } else {
        console.log("Has service data");
        console.log(data);
        this.services.push({
          type: "service",
          invoice_template_detail_id: null,
          invoice_template_detail_item: {id:data.service_id, text:data.service_name, type:null},
          invoice_template_detail_part_id: null,
          invoice_template_detail_service_id: data.service_id,
          invoice_template_detail_invoice_template_id: that.invoicetemplateId,
          invoice_template_detail_description: data.service_description,
          invoice_template_detail_hours: data.service_quantity_per_hour,
          service_index: index,
          invoice_template_detail_order: index,
          expanded: false,
          parts: [] 
        });
        if (data.part && data.part != null && data.part != undefined) {
          this.services[index].parts.push({ 
              type: "part",
              new: "NEWWWWW",
              invoice_template_detail_id: null,
              invoice_template_detail_item: { id: data.part.part_id, text: this.formatPartDisplay(data.part), type: null },
              invoice_template_detail_part_id: data.part.part_id,
              invoice_template_detail_service_id: null,
              invoice_template_detail_invoice_template_id: that.invoicetemplateId,
              invoice_template_detail_description: data.part.part_name,
              invoice_template_detail_qty: "1.00",
              invoice_template_detail_hours: "0.00",
              service_index: index,
              invoice_template_detail_order: index+1,
              part_inventory: data.part.part_inventory,
              part_return: data.part.part_return,
              part_index: 0
            }
          );
          this.services[index].expanded = true;
        }
      }
      this.recomputeItems();
    },
    removeItem: function(service_index, part_index){
      let _this = this;
      var msg = ""
      //var service = _this.services[service_index];
      var title = "";
      msg = "Êtes-vous sûr de supprimer cet item"
      title = "Supprimer un item";
      bootbox.dialog({
        title: title,
        message: msg,
        buttons: {				
          remove: {
            label: L('YES_WORD'),
            className: "btn-danger",
            callback: function() {
              if(part_index === undefined){
                _this.services.splice(service_index, 1);
              }
              else{
                _this.services[service_index].parts.splice(part_index, 1);
              }
              _this.recomputeItems();
              _this.saveItems();
            }
          },					
          cancel: {
            label: L("CANCEL"),
            className: "btn",
            callback: function() {

            }
          }
        }
      })
      
    },
    addPart: function(ix){
      var that = this;
      var service = this.services[ix];

      var index = 0;
      if(service.parts[service.parts.length-1] !== undefined){
        index = parseInt(service.parts[service.parts.length-1].invoice_template_detail_order) + 1;
      }

      //console.log(service.parts)

      service.parts.push({
        type: "part",
        new: "NEWWWWW",
        invoice_template_detail_id: null,
        invoice_template_detail_item: { id: null, text: "", type: null },
        invoice_template_detail_part_id: null,
        invoice_template_detail_service_id: null,
        invoice_template_detail_invoice_template_id: that.invoicetemplateId,
        invoice_template_detail_description: "",
        invoice_template_detail_price: "0.00",
        invoice_template_detail_qty: "1.00",
        invoice_template_detail_hours: "0.00",
        service_index: ix,
        invoice_template_detail_order: index,
        part_index: index
      })
      service.expanded = true;
      this.recomputeItems();

      setTimeout(() => {
        var count = service.parts.length;
        // console.log(that.$refs["select2-part-"+ix+"-"+(count-1)][0]);
        that.$refs["select2-part-"+ix+"-"+(count-1)][0].openFocus = true;
      }, 50)
    },
    onSelect: function(service_index, part_index, item){
      var split = item.id.toString().split("-");
      var id = split[1];
      var type = split[0];

      if(part_index === undefined) { // Service
        this.services[service_index].invoice_template_detail_part_id = null;
        this.services[service_index].invoice_template_detail_service_id = id;
        this.services[service_index].invoice_template_detail_description = item.description;
        this.services[service_index].invoice_template_detail_qty = item.service_quantity_fixed;
        this.services[service_index].invoice_template_detail_hours = 0;
      }
      else { // Pièce
        for (const part of this.allItems) {
          if(part.type == "part" && part.invoice_template_detail_part_id == id && part != item) {
            item.part_inventory = part.part_inventory;
            item.part_return = part.part_return;
            break;
          }
        }

        this.services[service_index].parts[part_index].invoice_template_detail_part_id = id;
        this.services[service_index].parts[part_index].invoice_template_detail_service_id = null;
        this.services[service_index].parts[part_index].invoice_template_detail_description = item.description;

      }

      this.updateCounter++;
      this.saveItems();
    },
    onClear: function(service_index, part_index){
      if(part_index === undefined) { // Service
        this.services[service_index].invoice_template_detail_part_id = null;
        this.services[service_index].invoice_template_detail_service_id = null;
      }
      else { // Pièce
        this.services[service_index].parts[part_index].invoice_template_detail_part_id = null;
        this.services[service_index].parts[part_index].invoice_template_detail_service_id = null;
      }
      this.updateCounter++;
    },
    cancelChanges: function(){
      let _this = this;
      bootbox.dialog({
        title: "Annuler les changements",
        message: "Êtes-vous sûr d'annuler les changements courants?",
        buttons: {				
          remove: {
            label: L('YES_WORD'),
            className: "btn-danger",
            callback: function() {
              _this.services = JSON.parse(JSON.stringify(_this.oldItems));
              _this.recomputeItems();
            }
          },					
          cancel: {
            label: L("CANCEL"),
            className: "btn",
            callback: function() {

            }
          }
        }
      })
    },
    handleChange() {
      let i = 0;
      for (const item of this.items) {
        item.invoice_template_detail_order = i++;
      }
      this.recomputeItems();
      this.saveItems();
    },
  }
}
</script>

<style lang="scss" scoped>
.invoice-template-details-portlet{
  td.input{
    padding: 2px !important;
  }

  td.cb{
    text-align: center;
  }

  td.cb input{
    width: 18px;
    height: 18px;
  }

  td.cb .invoice_template_detail_parts_status_div{
    vertical-align: top;
  }

  td.cb input.invoice_template_detail_parts_status{
    width: 14px;
    height: 14px;
    margin-top: 0;
    vertical-align: middle;
  }

  .width-min-nowrap{
    width: 1%;
    white-space: nowrap;
  }
  
  .item-row:hover{
    background-color: rgb(204, 232, 255) !important;
  }

  .is-done {
    background-color: rgb(175, 175, 175) !important;
  }

  .item-row {
    &.is-service {
      background-color: #fff;
      border-top: 50px solid #e7ecf1;

      td {
        padding-top: 8px !important;
      }
    }

    &:not(.is-service) {
      background-color: #cedae6
    }
  }

  input.invoice_template_detail_hours, input.invoice_template_detail_hour_rate  {
    color: #fff;
    background-color: #26c281;
  }

}
</style>
